<template>
  <v-container class="ctnr input-text-size">
    <CRUDDialog
      :baseCrudKey='baseCrudKey'
      :canSave="false"
      :canCancel="false"
      :tabsList="tabsList"
      ref="crudDialog"
      :dialogDynamicWidth="wideDialogWidth"
      :dialogDynamicHeight="wideDialogHeight"
      ><template v-slot:[`editedItem`]="{}">
        <TaxInquiryDialog
          v-if="isDialogVisible"
          :baseCrudKey="baseCrudKey"
          :baseCrudKeyForFeeList="baseCrudKeyForFeeList"
          :feeListBasedInIds="feeListBasedInIds"
          :attachmentConstants="attachmentConstants"
          @upsertItem="upsertRecords"
        />
        </template>
        <template v-slot:[`additionalActions`]="{}">
          <span v-if="getUpdatedTabVal === 0">
            <v-row>
              <v-btn class="input-text-size" text color="blue darken-1"
            @click="handleSMSDialog">SMS</v-btn>
              <v-btn
                class="input-text-size"
                text
                color="blue darken-1"
                @click="printStatement"
                >Print Statement</v-btn
              >
              <v-btn class="input-text-size" text color="blue darken-1"
               @click="handleEmailStatement"
                >Email Statement</v-btn
              >

              <v-btn class="input-text-size" text color="blue darken-1"
               @click="printInfoSheet"
                >info sheet</v-btn
              >

              <v-btn
                class="input-text-size tax-roll-transaction-list-add-to-list-btn"
                id="taxRollTransactionListAddToListBtn"
                text
                color="blue darken-1"
                @click="addToList"
              >
                Add to List
              </v-btn>
              <v-btn
                class="input-text-size tax-roll-transaction-list-pay-now-btn"
                id="taxRollTransactionListPayNowBtn"
                text
                color="blue darken-1"
                @click="handlePaymentDialogClick"
              >
                Pay Now
              </v-btn>
              <UploadFile
                class="mtgtrans uploadFile"
                text
                :bucketName="attachmentConstants.bucketName"
                :program="attachmentConstants.program"
                :parentObjectType="attachmentConstants.parentObjectType"
                :parentObjectId="getActiveTransID || ''"
                :itemIsSaved="!isNewItem"
              >
                <template v-slot:activator="{ activatorProps }">
                  <v-btn
                    class="input-text-size"
                    text
                    color="blue darken-1"
                    @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
                    @click="imagesLeftClick(activatorProps.leftClick)"
                  >
                    {{ activatorProps.caption }}
                  </v-btn>
                </template>
              </UploadFile>
              <AuditDialog
                v-if="getActiveTransID"
                :identifier="getActiveTransID"
                activatorCaption="Audit History"
                activatorCaptionStyle="input-text-size"
              />
            </v-row>
          </span>
        </template>
        <template v-slot:[`additionalActionsAfterSave`]="{}">
          <v-btn
            class="input-text-size tax-roll-transaction-list-save-btn"
            id="taxRollTransactionListSaveBtn"
            text
            color="blue darken-1"
            v-if="!areTheyAreForms()"
            @click="upsertRecords(false)"
          >
            Save
          </v-btn>
          <v-btn
            class="input-text-size tax-roll-transaction-list-cancel-close-btn"
            id="taxRollTransactionListCancelCloseBtn"
            text
            color="blue darken-1"
            @click="closeDialog"
          >
            {{ !areTheyAreForms() ? 'Cancel' : 'Close' }}
          </v-btn>
        </template>
      </CRUDDialog>
    <CommonPaymentDialog ref="commonPayment" :baseCrudKey="paymentCrudKey"
    :fromCompBaseCrudKey="baseCrudKey" />
      <!-- dialog for address update -->
      <CRUDDialog
        :baseCrudKey='emailStatementCrudKey'
        :canSave="true"
        canSaveCustomLabel="Send"
        :onlyDialogHeaderName="emailStatementHeader"
        @upsertItem="handleEmail"
        dialogDynamicWidth='550'
      ><template v-slot:[`editedItem`]="{}">
          <EmailStatementDialoge :baseCrudKey="emailStatementCrudKey" />
        </template>
      </CRUDDialog>
      <CRUDDialog
        :baseCrudKey='comDialogCrudKey'
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Create Comment for Owner Info changes"
        @upsertItem="handleComment"
        dialogDynamicWidth='550'
      ><template v-slot:[`editedItem`]="{}">
         <CommentDialog :baseCrudKey="comDialogCrudKey"/>
        </template>
      </CRUDDialog>
      <CRUDDialog
        :baseCrudKey='comDialogCrudKeyForTax'
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Create Comment for Tax Info changes"
        @upsertItem="handleCommentForTax"
        dialogDynamicWidth='550'
      ><template v-slot:[`editedItem`]="{}">
         <CommentDialog :baseCrudKey="comDialogCrudKeyForTax"/>
        </template>
      </CRUDDialog>
      <CRUDDialog
      v-if="destroyOrReRenderAdjComp"
      :baseCrudKey='adjDialogCrudKey'
      :canSave="true"
      :canCancel="false"
      onlyDialogHeaderName="Creating Adjustment Record for Owner Info changes"
      @upsertItem="handleAdjUpdate"
      dialogDynamicWidth='400'
      ><template v-slot:[`editedItem`]="{}">
        <CreateAdjTaxDialog :baseCrudKey="adjDialogCrudKey"/>
        </template>
      </CRUDDialog>
      <CRUDDialog
        v-if="destroyOrReRenderTaxInfoAdjComp"
        :baseCrudKey='adjDialogForTaxInfoCrudKey'
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Creating Adjustment Record for Tax Info changes"
        @upsertItem="handleAdjTaxRollUpdate"
        dialogDynamicWidth='400'
        ><template v-slot:[`editedItem`]="{}">
          <CreateAdjTaxDialog :baseCrudKey="adjDialogForTaxInfoCrudKey"/>
        </template>
      </CRUDDialog>
      <!-- for sms -->
      <CRUDDialog
        :baseCrudKey='smsCrudKey'
        :canSave="true"
        :onlyDialogHeaderName="smsDialogtHeader"
        @upsertItem="generateSMS"
        dialogDynamicWidth='550'
        canSaveCustomLabel="Send"
      ><template v-slot:[`editedItem`]="{}">
          <SmsDialog :baseCrudKey="smsCrudKey" />
        </template>
      </CRUDDialog>
    <!-- </v-container> -->
  </v-container>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import {
  getChangedFields,
  makeCriteriaStateNullIfEmptyString,
  taxCommonPostProcessTrans,
  taxFeeCheckWitheEfectiveDate,
} from '../common-utils/CommonTaxFunctionalities';
import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';
import { generateQueryString } from '../../common/base/report/report-util';
import { clients } from '../../../util/clients';
import { getRawJwt } from '../../../util/jwt';
import { toIsoDate, toShortDate } from '../../../util/shared/tmc-global';
import {
  commonAdjFuncForTaxrollNOwner, exemptManufacturingStatusCode, taxCommentTypesObj, toOwnerChangesInput,
} from '../common-utils/tax-common.util';
import { zipDeFormat } from '../../../util/shared/vue-global';
import CommonPaymentDialog from '../TaxInquiry/Common/CommonPaymentDialog.vue';
import TaxInquiryDialog from '../TaxInquiry/Common/TaxInquiryDialog.vue';
import CreateAdjTaxDialog from '../TaxCommonComponents/createAdjTaxDialog.vue';
import { tabsForTaxRollWorkFile } from './utils/trWorkFileHeaders';
import CommentDialog from '../TaxCommonComponents/commentDialog.vue';
import SmsDialog from '../TaxInquiry/Common/smsDialog.vue';
import EmailStatementDialoge from '../TaxInquiry/Common/EmailStatementDialoge.vue';
import AuditDialog from '../../common/audit/AuditDialog.vue';
import UploadFile from '../../common/UploadFile.vue';
import { printerHandler } from '../../../util/pdf-to-printer.util';
import taxSmsDialogMixin from '../common-utils/taxSmsDialog.mixin';
import { WIDE_DIALOG_HEIGHT, WIDE_DIALOG_WIDTH } from '../../../util/shared/dialog-size';

const { backendRest } = clients.direct;

export default {
  name: 'TaxRollDialogForBrowswTRWorkFile',
  mixins: [taxSmsDialogMixin],
  components: {
    CRUDDialog,
    CommonPaymentDialog,
    TaxInquiryDialog,
    CreateAdjTaxDialog,
    CommentDialog,
    SmsDialog,
    EmailStatementDialoge,
    AuditDialog,
    UploadFile,
  },
  data() {
    return {
      // the tax record dialog's size - shared with the other three hosts of TaxInquiryDialog
      wideDialogWidth: WIDE_DIALOG_WIDTH,
      wideDialogHeight: WIDE_DIALOG_HEIGHT,
      baseCrudKey: 'TaxrollTransactionList',
      baseCrudKeyForFeeList: 'TaxrollTransactionFeeList',
      emailStatementCrudKey: 'emailStatement',
      paymentCrudKey: 'paymentTransactionList',
      emailStatementHeader: 'Email Send',
      comDialogCrudKey: 'comDialog',
      comDialogCrudKeyForTax: 'comDialogForTaxInfo',
      adjDialogCrudKey: 'createAdjTaxDialog',
      adjDialogForTaxInfoCrudKey: 'createAdjTaxInfoDialog',
      smsCrudKey: 'smsTransaction',
      destroyOrReRenderTaxInfoAdjComp: false,
      smsDialogtHeader: 'SMS Info',
      activeTransItem: undefined,
      destroyOrReRenderAdjComp: false,
      originalItem: null,
      attachmentConstants: {
        bucketName: 'taxInquiry',
        program: 'taxInquiry',
        parentObjectType: 'taxInquiryTransaction',
      },
      uploadFileParams: {
        bucketName: 'taxInquiry',
        program: 'taxInquiry',
        parentObjectType: 'taxInquiryTransaction',
      },
      uploadFileClickParams: {
        leftClickFlag: false,
        leftClickDef: undefined,
        rightClickFlag: false,
        rightClickDef: undefined,
      },
    };
  },
  async created() {
    await this.$store.dispatch('SystemConfig/loadConfig', { requiredScope: 'paymentConfig' });
  },
  props: {
    tabsList: {
      type: Array,
      default: () => [...tabsForTaxRollWorkFile],
    },
    userName: {
      type: String,
      default: '',
    },
    wkstNumber: {
      type: String,
      default: '',
    },
  },
  watch: {
    getActiveTransID(newVal) {
      if (newVal) {
        this.originalItem = JSON.parse(JSON.stringify(this.item(this.baseCrudKey)));
      }
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'items',
      'item',
      'index',
      'selectedTab',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      feeListBasedInIds: (state) => state.base.crud.items.TaxrollTransactionFeeList,
      statementSettingItem: (state) => state.SystemConfig.statementSettingItem || {},
      isDialogVisible: (state) => state.base.crud.isVisible.TaxrollTransactionList,
    }),
    getUpdatedTabVal: {
      get() {
        return this.selectedTab(this.baseCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKey, value]);
      },
    },
    editEmailItem: {
      get() {
        return this.item(this.emailStatementCrudKey);
      },
      set(value) {
        this.setItem([this.emailStatementCrudKey, value]);
      },
    },
    editSMSItem: {
      get() {
        return this.item(this.smsCrudKey);
      },
      set(value) {
        this.setItem([this.smsCrudKey, value]);
      },
    },
    getActiveTransID() {
      return this.item(this.baseCrudKey)._id;
    },
    isNewItem() {
      return false;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setItems',
      'setItem',
      'setSelectedTab',
      'setIndex',
    ]),
    ...mapActions('tax/taxInquires', [
      'sendMail',
    ]),
    ...mapActions(['custumColrFlashMsg']),
    ...mapMutations('tax/taxInquiryTabs', ['setComments']),
    ...mapActions('tax/taxRollAdjustments', ['upsertTaxRollAdjustments']),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
      'upsertTaxInquiryTransaction',
      'patchTaxInquiryTransaction',
      'callMakeGLobalTaxIdUndefined',
    ]),
    ...mapActions('tax/taxFee', [
      'loadTaxRollFeesTable',
      'multipleUpsertTaxFees',
      'taxFeesBasedOnIds',
    ]),
    ...mapActions('tax/taxInquiryTabs', [
      'UpsertPickListSingleNMultiplipleHybrid',
      'loadTabsAdjustments',
    ]),
    ...mapActions(['reAuth']),
    ...mapActions('tax/taxComments', ['loadTaxComments', 'upsertTaxCommentTrans']),
    getAuthToken() {
      return getRawJwt();
    },
    async handleEmail() {
      const itemData = this.item(this.baseCrudKey);
      const {
        bccEmailAddress, emailAdd, subjectBody, subjectLine, taxId, taxYear, saveEmailToRecord,
      } = this.editEmailItem;
      const penaltyDate = itemData.penaltyDateValue || toShortDate();
      const item = {
        email: emailAdd,
        bccEmailAddress,
        subject: subjectLine,
        subjectBody,
        saveEmailToRecord: !!saveEmailToRecord,
        taxYear: parseInt(taxYear, 10),
        taxId: parseInt(taxId, 10),
        ids: itemData._id,
        token: this.getAuthToken(),
        penaltyDate,
        wkstId: Number(this.wkstNumber),
      };
      this.sendMail({ item });
      // alert('handle email', item);
    },
    async printStatement() {
      const item = this.item(this.baseCrudKey);
      if (!item._id) {
        return;
      }
      const { jwt } = await this.reAuth();
      const penaltyDate = item.penaltyDateValue || toShortDate();
      const params = [
        `token=${jwt}`,
        `wkst=${Number(this.wkstNumber)}`,
        `penaltyDate=${penaltyDate}`,
        `ids=${item._id}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/taxInquiry/pick-list/printStatement${queryString}`;
      // window.open(url);
      printerHandler(this, { url, reportName: 'taxStatements', deafultPrinterMode: true });
    },
    handleEmailStatement() {
      const itemData = this.item(this.baseCrudKey);
      this.editEmailItem.taxYear = itemData.taxYear;
      this.editEmailItem.taxId = itemData.taxId;
      this.editEmailItem.emailAdd = itemData.emailAddess;
      // Default ON when the record has no address on file yet, OFF when the field is
      // pre-filled with what's already stored - the user can always override before sending.
      this.editEmailItem.saveEmailToRecord = !itemData.emailAddess;
      this.editEmailItem.bccEmailAddress = this.statementSettingItem.bccEmailAddress;
      this.editEmailItem.subjectLine = this.statementSettingItem.subjectLine;
      this.editEmailItem.subjectBody = this.statementSettingItem.subjectBody;
      this.setIsVisible([this.emailStatementCrudKey, true]);
    },
    async imagesLeftClick(leftClick) {
      if (this.isNewItem) {
        await this.$refs.crudDialog.apply();
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNewItem) {
        await this.$refs.crudDialog.apply();
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
      } else {
        rightClick();
      }
    },
    async handleComment(updatedItem) {
      const item = updatedItem;
      item.comment = `${item.fixedComment} ${(updatedItem.comment || '').replace(/\n/g, '')}`;
      item.userName = this.userName;

      if (item.reasonCode) { // to add reason-desc to the comment
        const reasonCodeWithDesc = (this.reasonListDropDown || [])
          .filter((ft) => ft.value === item.reasonCode);
        if (reasonCodeWithDesc.length) {
          item.comment = `${item.comment} Per ${reasonCodeWithDesc[0].name}`;
        }
      }
      delete item.fixedComment;
      await this.upsertTaxCommentTrans({
        item,
        baseCrudKey: this.comDialogCrudKey,
      }).then(() => {
        this.setItem([this.comDialogCrudKey, {}]);
      });
    },
    handleAdjTaxRollUpdate(updatedItem) {
      const adjItem = updatedItem;
      adjItem.certDate = updatedItem.certDate ? toIsoDate(updatedItem.certDate) : toIsoDate();
      adjItem.adjDate = toIsoDate();
      adjItem.adjOrUpd = 'UPDATE';
      this.upsertTaxRollAdjustments({
        item: adjItem,
      }).then(() => {
        this.setItem([this.adjDialogForTaxInfoCrudKey, {}]);
        this.destroyOrReRenderTaxInfoAdjComp = false;
      }).catch((err) => console.error(err));
    },
    taxPostProcessTrans(items) {
      const penaltyDateValue = toShortDate();
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const updatedItems = taxCommonPostProcessTrans(items,
        this.todaysDate, this.taxSettingItem, penaltyDateValue,
        formatPidPositions);
      return updatedItems;
    },
    setDefaultComments() {
      this.$nextTick(() => {
        this.setComments([]);
      });
    },
    // checkFormValidOrNot(whatColor = '') {
    //   const mappedArr = (tabsForTaxRollWorkFile || []).map((ft) => {
    //     const item = ft;
    //     if (item.id === 0) item.color = whatColor;
    //     if (item.id === 1) item.color = whatColor;
    //     return item;
    //   });
    //   this.tabsList = mappedArr;
    // },
    async upsertRecords(isFromTaxInquiryDialog = false) {
      const validate = this.$refs.crudDialog.validateForm();
      // this.checkFormValidOrNot('red');
      if (!validate) return;
      const item = this.item(this.baseCrudKey);
      const updatedItem = { ...item };
      const { baseCrudKey } = this;
      const getAllFeeTotal = taxFeeCheckWitheEfectiveDate(this.taxRollFeesTable, this.todaysDate);
      updatedItem.userName = this.userName;
      updatedItem.wkstNumber = this.wkstNumber;
      updatedItem.schoolDistrict = updatedItem.taxDistrict;
      updatedItem.zip = zipDeFormat(updatedItem.zip);
      updatedItem.propertyOrParcelId = (updatedItem.propertyOrParcelId || '').replace(/-/g, '');
      updatedItem.mhPropertyOrParcelId = (updatedItem.mhPropertyOrParcelId || '').replace(/-/g, '');
      updatedItem.pIdOfRealEstate = (updatedItem.pIdOfRealEstate || '').replace(/-/g, '');
      updatedItem.penaltyStartDate = updatedItem.penaltyStartDate
        ? toIsoDate(updatedItem.penaltyStartDate) : updatedItem.penaltyStartDate;
      updatedItem.mhDecalDate = updatedItem.mhDecalDate
        ? toIsoDate(updatedItem.mhDecalDate) : updatedItem.mhDecalDate;
      const isExemptManufacturing = (updatedItem.statusCode || [])
        .includes(exemptManufacturingStatusCode);
      updatedItem.totalFee = isExemptManufacturing ? 0 : getAllFeeTotal;
      delete updatedItem.taxDistrict;
      delete updatedItem.hasFiles;
      delete updatedItem.getPenRateWithMonths;
      delete updatedItem.penaltyAmount;
      delete updatedItem.penaltyDateValue;
      delete updatedItem.feesAndPen;
      delete updatedItem.totalDueIsNegative;
      // Compute only the changed fields for patch
      const changedKeys = this.originalItem
        ? new Set(Object.keys(getChangedFields(this.originalItem, item)))
        : null;
      let patchPayload;
      if (changedKeys) {
        patchPayload = { _id: updatedItem._id };
        patchPayload.userName = updatedItem.userName;
        patchPayload.wkstNumber = updatedItem.wkstNumber;
        Object.keys(updatedItem).forEach((key) => {
          if (changedKeys.has(key)) {
            patchPayload[key] = updatedItem[key];
          }
        });
        // taxDistrict is renamed to schoolDistrict in the transformation
        if (changedKeys.has('taxDistrict')) {
          patchPayload.schoolDistrict = updatedItem.schoolDistrict;
        }
      } else {
        patchPayload = updatedItem;
      }
      const returnRes = makeCriteriaStateNullIfEmptyString(patchPayload);
      const returnedVal = await this.patchTaxInquiryTransaction({
        item: returnRes,
        baseCrudKey,
        postProcessTrans: this.taxPostProcessTrans,
      });
      // this is used to create adjustment and comment
      if ((returnedVal || {}).commentForTaxInfoChanges || (returnedVal || {}).commentOnlyForOwner) {
        if ((returnedVal || {}).commentForTaxInfoChanges) { // tax-info changes
          const commentItem = {
            taxYear: (returnedVal || {}).taxYear,
            taxId: returnedVal.taxId,
            beforeChange: returnedVal.beforeChangeForTax,
            afterChange: returnedVal.afterChangeForTax,
            category: taxCommentTypesObj.taxRecordCode,
            taxInquiryTransaction: returnedVal._id,
          };
          commentItem.fixedComment = returnedVal.commentForTaxInfoChanges;
          commentItem.comment = '';
          commentItem.createdAt = returnedVal.commentCreatedDate || toIsoDate();

          if (this.checkTheUserIsTaxAdmin) {
            // for tax-admin we can automatically create comment
            this.handleCommentForTax(commentItem);
          } else {
            this.setItem([this.comDialogCrudKeyForTax, commentItem]);
            this.setIsVisible([this.comDialogCrudKeyForTax, true]);
          }
          if (this.taxSettingItem.updateTaxrollChangesAdjFlag) {
            const adjItem = commonAdjFuncForTaxrollNOwner(returnedVal,
              this.taxSettingItem.updateTaxrollChangesAdjType);
            this.setItem([this.adjDialogForTaxInfoCrudKey, adjItem]);
            this.destroyOrReRenderTaxInfoAdjComp = true;
            this.setIsVisible([this.adjDialogForTaxInfoCrudKey, true]);
          }
        }
        if ((returnedVal || {}).commentOnlyForOwner) { // owner info changes
          const commentItem = {
            taxYear: returnedVal.taxYear,
            taxId: returnedVal.taxId,
            beforeChange: returnedVal.beforeChange,
            afterChange: returnedVal.afterChange,
            ownerChanges: toOwnerChangesInput(returnedVal.ownerChanges),
            category: taxCommentTypesObj.ownerInfoCode,
            taxInquiryTransaction: returnedVal._id,
          };
          commentItem.fixedComment = returnedVal.commentOnlyForOwner;
          commentItem.comment = '';
          commentItem.createdAt = returnedVal.commentCreatedDate || toIsoDate();
          this.setItem([this.comDialogCrudKey, commentItem]);
          this.setIsVisible([this.comDialogCrudKey, true]);
          if (this.taxSettingItem.updateOwnerChangesAdjFlag) {
            const adjItem = commonAdjFuncForTaxrollNOwner(returnedVal,
              this.taxSettingItem.updateOwnerChangesAdjType);
            this.setItem([this.adjDialogCrudKey, adjItem]);
            this.destroyOrReRenderAdjComp = true;
            this.setIsVisible([this.adjDialogCrudKey, true]);
          }
        }
      }
      if (!isFromTaxInquiryDialog) this.closeDialog();
      await this.callMakeGLobalTaxIdUndefined({ type: 'omittedProperties' });
      this.originalItem = null;
    },
    handleAdjUpdate(updatedItem) {
      const adjItem = updatedItem;
      adjItem.certDate = updatedItem.certDate ? toIsoDate(updatedItem.certDate) : toIsoDate();
      adjItem.adjDate = toIsoDate();
      adjItem.adjOrUpd = 'UPDATE';
      this.upsertTaxRollAdjustments({
        item: adjItem,
      }).then(() => {
        this.setItem([this.adjDialogCrudKey, {}]);
        this.destroyOrReRenderAdjComp = false;
      }).catch((err) => console.error(err));
    },
    async printInfoSheet() {
      const item = this.item(this.baseCrudKey);
      if (!item._id) {
        return;
      }
      const { jwt } = await this.reAuth();

      const to = `taxInquiry/pick-list/printInfoSheet?ids=${item._id}&reportname'infosheet'&token=${jwt}&wkst=${Number(this.wkstNumber)}`;
      const toUrl = `${backendRest.defaults.baseURL}/${to}`;
      // window.open(toUrl);
      printerHandler(this, { url: toUrl, reportName: 'infoSheets', deafultPrinterMode: true });
    },
    async addToList() {
      const itemData = this.item(this.baseCrudKey);
      if (Object.keys(itemData).length > 0) {
        const pickListProfileName = localStorage.getItem('pick-list-profile-name');
        const item = {
          mutipleIds: [itemData._id],
          // workstation: Number(this.wkstNumber),
          addUnpaids: this.paymentSettingItem.loadUnpaidsAutomatically || false,
        };
        // if profile name is present then use it otherwise use workstation
        if (pickListProfileName) item.profileName = pickListProfileName;
        else item.workstation = Number(this.wkstNumber);
        await this.UpsertPickListSingleNMultiplipleHybrid({
          item,
          baseCrudKey: 'pickListTable',
        });
      }
    },
    handlePaymentDialogClick() {
      this.setIndex(['paymentTransactionList', -1]);
      this.$refs.commonPayment.handlePaymentDialog();
    },
    async handleCommentForTax(updatedItem) {
      const item = updatedItem;
      item.comment = `${item.fixedComment} ${(updatedItem.comment || '').replace(/\n/g, '')}`;
      item.userName = this.userName;

      if (item.reasonCode) { // to add reason-desc to the comment
        const reasonCodeWithDesc = (this.reasonListDropDown || [])
          .filter((ft) => ft.value === item.reasonCode);
        if (reasonCodeWithDesc.length) {
          item.comment = `${item.comment} Per ${reasonCodeWithDesc[0].name}`;
        }
      }
      delete item.fixedComment;
      await this.upsertTaxCommentTrans({
        item,
        baseCrudKey: this.comDialogCrudKeyForTax,
      }).then(() => {
        this.setItem([this.comDialogCrudKeyForTax, {}]);
      });
    },
    closeDialog() {
      this.getUpdatedTabVal = 0;
      this.setIsVisible([this.baseCrudKey, false]);
    },
    areTheyAreForms() {
      // to chheck if the form is in adjustment or comment
      if (this.getUpdatedTabVal === 2 || this.getUpdatedTabVal === 3) return true;
      return false;
    },
  },
};
</script>
